<template>
  <div class="container-fluid">
    <div class="row mb-5">
      <div class="col-8">
        <span class="display-4 col-12">{{ $t("COMMON.PAYMENTS") }}</span>
      </div>
    </div>

    <sales-payment-list-table
      v-if="salesInvoice.id"
      :showHeader="false"
      :filterInvoice="salesInvoice.id"
    />

    <div class="row mb-5">
      <div class="col-6"></div>
      <div class="col-6">
        <dl class="row mb-0">
          <dt class="col-sm-6">{{ $t("COMMON.TOTAL_PAIED") }}</dt>
          <dd class="col-sm-6 text-right">
            {{
              salesInvoice.total_paied !== undefined
                ? $formatCurrency(salesInvoice.total_paied)
                : null
            }}
          </dd>
        </dl>
      </div>
    </div>
  </div>
</template>

<script>
import formMixin from "@/mixins/form-mixin";
import SalesPaymentListTable from "../../SalesPaymentManagement/partials/SalesPaymentListTable.vue";

export default {
  name: "sales-invoice-view-details",

  components: {
    SalesPaymentListTable,
  },

  mixins: [formMixin],

  props: ["salesInvoice", "get"],

  data() {
    return {};
  },

  computed: {},

  methods: {},

  mounted() {},

  watch: {},
};
</script>
